angular.module('unica_track.track_controllers', [])

.controller('TrackBasicController',
	function(
		$rootScope, $scope, $stateParams,
		TrackListService
	) {

	$scope.forms = {};

	$rootScope.trackData = {
		event_id: $stateParams.event_id,
	};

	$rootScope.getTrack = function(trackId)
	{
		$scope.showLoader();

		TrackListService
			.get(trackId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.trackData = data;
			});
	};



});


